import { Package } from '../types';
import destinationsData from '../data/destinations.json';

export interface Destination {
  id: string;
  name: string;
  country: string;
  packages: Package[];
}

export const destinations: Destination[] = destinationsData.destinations;

// Legacy export for backward compatibility
export const packageData: Package[] = destinations.flatMap(dest => dest.packages); 